import { Component, Input, Output, EventEmitter } from "@angular/core";
import { IconDefinition } from "@fortawesome/free-solid-svg-icons";

@Component({
  selector: "app-stepper-base-button",
  templateUrl: "./stepper-base-button.component.html",
  styleUrls: ["./stepper-base-button.component.scss"],
})
export class StepperBaseButtonComponent {
  @Input() actionText: string;
  @Input() contentBlock: boolean;
  @Input() actionIcon: IconDefinition;
  @Input() height = "100px";
  @Input() width = "100px";
  @Output() onClick: EventEmitter<any> = new EventEmitter();

  onActionClick() {
    this.onClick.emit();
  }
}
